/**
 * Retrieves the value at a given path within a nested object.
 *
 * @param {Object} obj - The object to query.
 * @param {string} path - The path of the property to get, with keys separated by dots.
 * @param {*} [defaultValue] - The value returned if the resolved value is undefined.
 * @return {*} - Returns the resolved value or the default value if the resolved value is undefined.
 */
export function getNestedValue(obj, path, defaultValue) {
  const keys = path.split('.');
  let result = obj;
  for (const key of keys) {
    result = result?.[key];
    if (result === undefined) {
      return defaultValue;
    }
  }
  return result;
}


/**
 * Injects user data into a target HTML element by fetching data from a specified URL.
 *
 * @param {string} fields - The fields to be fetched from the user data.
 * @param {HTMLElement} targetElement - The target HTML element where the user data will be injected.
 * @return {Promise<void>} A promise that resolves when the user data has been successfully injected.
 * @throws {Error} Throws an error if there is an issue fetching the user data.
 */
export async function injectUserData(fields, targetElement) {
  const method = 'GET';
  const url = `${CoreJS.Constants.REC_URL_CONSTANT.me}?fields=${fields}`;
  const getUserFilterData = { fields: fields };

  try {
    if (targetElement) {
      const response = await CoreJS.CommonUtils.toggleEnvironment(url, method, getUserFilterData);
      const getValue = getNestedValue(response, fields);
      targetElement.innerHTML = targetElement.innerHTML.replace(
        `\${${fields}}`,
        CoreJS.CommonUtils.userLoginStatus() ? getValue : ''
      );
      targetElement.classList.remove('hidden');
    }
  } catch (error) {
    throw new Error('Error fetching user data:', error);
  }
}
